const internal_url = "https://app.purpleapp.net";
//const internal_url = 'http://127.0.0.1:8000';
const Url = `${internal_url}/restaurants`;
const AppUserUrl = `${internal_url}/delivery/appuser`;
export { Url, AppUserUrl };
